import { ContentType } from '@heidi/schema/ml-scribe';

/**
 * A stored JSON sectional note whose prior result is still the note in use:
 * completed, or a failed regeneration that kept the old JSON content. The
 * regenerate-retry path caches `FAILED` with the old result, and a real first
 * generation has no prior result, so this is the arm condition for preserving
 * the stored format on re-generation.
 *
 * A pure note-state predicate shared by the note pane and the non-React
 * stream handler, so it lives in `@/utils/integration` next to
 * `isStructuredNoteResult` rather than a container's private hooks folder.
 */
export const isJsonNoteInUse = (
  consultNote:
    | { content_type?: ContentType | null; result?: string | null }
    | null
    | undefined
): boolean => {
  return consultNote?.content_type === ContentType.JSON && Boolean(consultNote?.result);
};
